import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {VehicleSwitcherComponent} from './vehicle-switcher.component';
import {TranslateModule} from '@ox/translate';
import {GeneralModalModule, VehiclePickerModule, GhostImageModule} from '@ox/ui';

@NgModule({
  declarations: [VehicleSwitcherComponent],
  imports: [
    CommonModule,
    TranslateModule,
    GeneralModalModule,
    VehiclePickerModule,
    GhostImageModule
  ],
  exports: [VehicleSwitcherComponent],
  providers: [BsModalRef, BsModalService]
})
export class VehicleSwitcherModule { }
